import * as React from "react";

interface IPoiDetailsAddressProps {
    addressline: string;
}

function PoiDetailsAddress({ addressline }: IPoiDetailsAddressProps) {
    return (<span className="street">{addressline}&nbsp;</span>);
}

export default PoiDetailsAddress;